export default __webpack_public_path__ + "static/media/stock-values.46f5ec99.svg";